import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from '../utils/webComponents';
import { useTheme } from '../context/ThemeContext';

const CustomAlert = ({ visible, title, message, buttons = [], onClose }) => {
  const { theme } = useTheme();
  
  if (!visible) return null;

  return (
    <View style={styles.overlay} onClick={(e) => e.target === e.currentTarget && onClose()}>
      <View style={[styles.alertContainer, { backgroundColor: theme.surface }]}>
        <View style={styles.alertContent}>
          <Text style={[styles.alertTitle, { color: theme.text }]}>{title}</Text>
          {message && <Text style={[styles.alertMessage, { color: theme.textSecondary }]}>{message}</Text>}
          
          <View style={styles.buttonContainer}>
            {buttons.map((button, index) => (
              <TouchableOpacity
                key={index}
                style={[
                  styles.alertButton,
                  button.style === 'destructive' 
                    ? { backgroundColor: theme.error, borderColor: theme.error } 
                    : { backgroundColor: theme.surface, borderColor: theme.border },
                  buttons.length === 1 && styles.singleButton,
                ]}
                onPress={() => {
                  if (button.onPress) button.onPress();
                  onClose();
                }}
              >
                <Text
                  style={[
                    styles.alertButtonText,
                    { color: button.style === 'destructive' ? 'white' : theme.text }
                  ]}
                >
                  {button.text}
                </Text>
              </TouchableOpacity>
            ))}
          </View>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2000,
  },
  alertContainer: {
    width: '90%',
    maxWidth: 400,
    borderRadius: 16,
    padding: 24,
    borderWidth: 1,
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)',
  },
  alertContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    width: '100%',
  },
  alertTitle: {
    fontSize: 20,
    fontWeight: '700',
    marginBottom: 16,
    textAlign: 'center',
    display: 'block',
  },
  alertMessage: {
    fontSize: 16,
    textAlign: 'center',
    marginBottom: 24,
    lineHeight: 1.5,
    display: 'block',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 12,
    width: '100%',
  },
  alertButton: {
    flex: 1,
    paddingVertical: 14,
    paddingHorizontal: 20,
    borderRadius: 12,
    borderWidth: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 44,
  },
  singleButton: {
    maxWidth: 200,
    alignSelf: 'center',
  },
  alertButtonText: {
    fontSize: 16,
    fontWeight: '600',
    textAlign: 'center',
  },
});

export default CustomAlert;
